// Shared bits of the /dashboard/typography real-page preview.
//
// The preview page (pages/Typography/TypographyPreview.js) shows public pages in
// an iframe named PREVIEW_FRAME_NAME. window.name survives navigation inside the
// frame, so the public app can tell it's being previewed even after the visitor
// clicks around: App.js then renders the public routes despite the admin login,
// TypographyScope blocks form submits, and the GA snippet in public/index.html
// stays off (it checks the same name — keep the two in sync).

export const PREVIEW_FRAME_NAME = 'jet-typography-preview';

// Class the preview adds to the frame's <html>; the server renders preview CSS
// under `html.jet-public.jet-typography-preview` so it outranks the published block.
export const PREVIEW_HTML_CLASS = 'jet-typography-preview';

export const isTypographyPreviewFrame = () =>
  typeof window !== 'undefined' && window.name === PREVIEW_FRAME_NAME;

// The editor hands its unsaved values to the preview tab through localStorage
// (same origin, different tab) and keeps them in sync while previewing.
const STORAGE_KEY = 'jet-typography-preview';
export const EDITOR_PAYLOAD_MAX_AGE_MS = 12 * 60 * 60 * 1000;

// settings: { roles, groups }
export function writeEditorPayload(settings) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ settings, updatedAt: Date.now() }));
  } catch (e) {
    // Storage unavailable (private mode / blocked) — the preview falls back to the saved draft.
  }
}

export function readEditorPayload() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (!parsed?.settings?.roles || Date.now() - parsed.updatedAt > EDITOR_PAYLOAD_MAX_AGE_MS) return null;
    return parsed;
  } catch (e) {
    return null;
  }
}

export const isEditorPayloadEvent = (e) => e.key === STORAGE_KEY;
